if (!customElements.get('bundle-pair-form')) {
	customElements.define(
		'bundle-pair-form',
		class BundlePairForm extends HTMLElement {
			connectedCallback() {
				this.button = this.querySelector('.bundle-pair__button');
				this.errorEl = this.querySelector('.bundle-pair__error');
				this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
				this.modal = document.getElementById(`BundlePairModal-${this.dataset.section}`);
				this.selectedVariantId = null;

				if (this.button) {
					this.button.addEventListener('click', () => this.openModal());
				}

				if (this.modal && !this.modal.dataset.bundleInit) {
					this.modal.dataset.bundleInit = 'true';
					this.modalSubmit = this.modal.querySelector('.bundle-pair-modal__submit');
					this.modalError = this.modal.querySelector('.bundle-pair-modal__error');
					this.refSizeEl = this.modal.querySelector('[data-bundle-ref-size]');

					const variantsScript = this.modal.querySelector('[data-bundle-main-variants]');
					try {
						this.mainVariants = variantsScript ? JSON.parse(variantsScript.textContent) : {};
					} catch (e) {
						this.mainVariants = {};
					}

					this.modal.querySelectorAll('.bundle-pair-modal__option').forEach((option) => {
						option.addEventListener('click', () => this.switchPanel(option));
					});
					this.modal.querySelectorAll('.bundle-pair-modal__sizes input[type="radio"]').forEach((input) => {
						input.addEventListener('change', () => this.selectSize(input));
					});
					if (this.modalSubmit) {
						this.modalSubmit.addEventListener('click', () => {
							if (!this.selectedVariantId) return;
							this.addBundle(this.selectedVariantId, this.modalSubmit, this.modalError);
						});
					}
				}
			}

			get mainVariantInput() {
				const form = document.getElementById(`product-form-${this.dataset.section}`);
				return form ? form.querySelector('[name="id"]') : null;
			}

			openModal() {
				if (!this.modal) return;
				const mainInput = this.mainVariantInput;
				if (this.refSizeEl && mainInput && this.mainVariants[mainInput.value]) {
					this.refSizeEl.textContent = this.mainVariants[mainInput.value];
				}
				this.modal.show(this.button);
			}

			switchPanel(option) {
				const targetId = option.dataset.targetProduct;

				this.modal.querySelectorAll('.bundle-pair-modal__option').forEach((o) => {
					const active = o === option;
					o.classList.toggle('is-selected', active);
					o.setAttribute('aria-pressed', active);
				});
				this.modal.querySelectorAll('.bundle-pair-modal__panel').forEach((panel) => {
					panel.hidden = panel.dataset.productId !== targetId;
				});

				this.clearSizeSelection();
				const activePanel = this.modal.querySelector(`.bundle-pair-modal__panel[data-product-id="${targetId}"]`);
				this.updateSubmitLabel(activePanel);
				this.showError(this.modalError, '');
			}

			clearSizeSelection() {
				this.selectedVariantId = null;
				this.modal.querySelectorAll('.bundle-pair-modal__sizes input[type="radio"]').forEach((input) => {
					input.checked = false;
				});
				if (this.modalSubmit) this.modalSubmit.setAttribute('disabled', '');
			}

			updateSubmitLabel(panel) {
				if (!this.modalSubmit || !panel) return;
				const labelEl = this.modalSubmit.querySelector('[data-bundle-submit-label]');
				if (labelEl && panel.dataset.bundlePrice) {
					labelEl.textContent = `${this.modalSubmit.dataset.label} — ${panel.dataset.bundlePrice}`;
				}
			}

			selectSize(input) {
				if (!input.checked) return;
				this.selectedVariantId = input.value;
				if (this.modalSubmit) this.modalSubmit.removeAttribute('disabled');
				this.showError(this.modalError, '');
			}

			showError(el, message) {
				if (!el) return;
				el.textContent = message;
				el.hidden = !message;
			}

			addBundle(pairId, uiButton, errorEl) {
				if (!uiButton || uiButton.getAttribute('aria-disabled') === 'true') return;
				this.showError(errorEl, '');

				const mainInput = this.mainVariantInput;
				if (!mainInput || mainInput.disabled || !pairId) {
					this.showError(errorEl, uiButton.dataset.errorGeneric);
					return;
				}

				uiButton.setAttribute('aria-disabled', true);
				uiButton.classList.add('loading');

				const config = fetchConfig('javascript');
				config.headers['X-Requested-With'] = 'XMLHttpRequest';
				delete config.headers['Content-Type'];

				const formData = new FormData();
				formData.append('items[0][id]', mainInput.value);
				formData.append('items[0][quantity]', '1');
				formData.append('items[1][id]', pairId);
				formData.append('items[1][quantity]', '1');
				if (this.cart) {
					formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
					formData.append('sections_url', window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				fetch(`${routes.cart_add_url}`, config)
					.then((response) => response.json())
					.then((response) => {
						if (response.status) {
							publish(PUB_SUB_EVENTS.cartError, {
								source: 'bundle-pair',
								productVariantId: pairId,
								errors: response.description,
								message: response.message,
							});
							this.showError(errorEl, response.description || uiButton.dataset.errorGeneric);
							return;
						}

						if (!this.cart) {
							window.location = window.routes.cart_url;
							return;
						}

						publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-pair', productVariantId: pairId });
						if (this.modal && this.modal.hasAttribute('open')) this.modal.hide();
						this.cart.renderContents(response);
						if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
					})
					.catch((e) => {
						console.error(e);
						this.showError(errorEl, uiButton.dataset.errorGeneric);
					})
					.finally(() => {
						uiButton.classList.remove('loading');
						uiButton.removeAttribute('aria-disabled');
					});
			}
		}
	);
}
